@let company = companyConfiguration$ | async;
@let companyLogo = companyLogo$ | async;
@let internalCompanyConfigurationLoaded = internalCompanyConfigurationLoaded$ | async;

<div class="rpc-additional-footer">

    <div class="rpc-additional-footer-content"
        [class.rpc-additional-footer-content--company]="company.internalId != null || internalCompanyConfigurationLoaded">

        @if (company.internalId != null || internalCompanyConfigurationLoaded)
        {
        <img class="rpc-additional-footer-company" [src]="companyLogo" [alt]="company.companyName">
        }

        <div class="rpc-additional-footer-powered" (click)="showVersion()">

            <rpc-icon class="rpc-additional-footer-powered-icon" [iconName]="'rp-icon'">
            </rpc-icon>

            <div class="rpc-additional-footer-powered-text">
                {{'ADDITIONAL_FOOTER.TITLES.POWERED_BY' | translate}}
            </div>

        </div>

    </div>

</div>